import { AfterViewInit, Directive, ElementRef, Host, Input, OnChanges, Optional, Renderer2, Self } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';

@Directive({
    selector: '[srpAsterisk]',
    standalone: false
})
export class AsteriskDirective implements AfterViewInit, OnChanges {
    @Input() srpAsterisk: boolean;
    @Input() srpAsteriskSelector = 'label.mat-form-field-label';

    private _placeholder: HTMLElement;

    constructor(
        private _elRef: ElementRef<HTMLElement>,
        private _renderer: Renderer2,
        @Host() @Self() @Optional() private _matFormField: MatFormField) {
        if (this._matFormField) {
            this._matFormField.hideRequiredMarker = true;
        }
    }

    ngOnChanges(): void {
        this.update();
    }

    ngAfterViewInit(): void {
        this._placeholder = this._elRef.nativeElement.querySelector(this.srpAsteriskSelector);
        this.update();
    }

    private update(): void {
        const styleName = 'mat-form-field-required';

        if (this.isRequired()) {
            this._renderer.addClass(this._elRef.nativeElement, styleName);
        } else {
            this._renderer.removeClass(this._elRef.nativeElement, styleName);
        }

        if (this._placeholder) {
            this._placeholder.blur();
        }
    }

    private hasRequiredValidator(control: AbstractControl): boolean {
        if (control.validator) {
            const errorState = control.validator({} as AbstractControl);
            return errorState?.required;
        }
        return false;
    }

    private isRequired(): boolean {
        if (this.srpAsterisk === undefined) {
            if (!this._matFormField ||
                !this._matFormField._control ||
                !this._matFormField._control.ngControl ||
                !this._matFormField._control.ngControl.control) {
                return true;
            }
            return this.hasRequiredValidator(this._matFormField._control.ngControl.control);
        }
        return this.srpAsterisk;
    }
}
